// anim easings

// mostly from http://gsgd.co.uk/sandbox/jquery/easing/ (BSD license)
// t: current time (start at 0), b: begInnIng value, c: change In value (as delta from b), d: duration
export const easings = {
  linear: function(t, b, c, d) {
    return b + c * (t/d);
  },
  easeInQuad: function (t, b, c, d) {
    return c*(t/=d)*t + b;
  },
  easeOutQuad: function (t, b, c, d) {
    return -c *(t/=d)*(t-2) + b;
  },
  easeInOutQuad: function (t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t + b;
    return -c/2 * ((--t)*(t-2) - 1) + b;
  },
  // utility function for easing arguments
  getEasing: function(easing) {
    switch (typeof easing) {
      case 'string':
        return utils.easings[easing];
      break;
      case 'function':
        return easing;
      break;
      case 'undefined':
        return utils.easings.DEFAULT_EASING;
      break;
    }
  }
};

export const DEFAULT_EASING = easings.linear;

export const DEFAULT_SMOOTH_SCROLL_DURATION = 300;


/**
 * Add an event listener that executes (only once!) on the next animation
 * frame following one or more of the given event. Registering the same
 * listener function for multiple events that can fire within the same
 * animation frame will result in only ONE call of the listener for that
 * frame.
 * @param  {Object} eventSource - anything with addEventListener
 * @param  {string} eventName
 * @param  {Function} listener
 */
export function onNextFrameAfterEvent(eventSource, eventName, listener) {
  function rafDebouncer(ev) {
    if (!listener._awaitingRAF) {
      window.requestAnimationFrame(function() {
        listener(ev);
        listener._awaitingRAF = false;
      });
      listener._awaitingRAF = true;
    }
  }
  eventSource.addEventListener(eventName, rafDebouncer);
};



var _dusTimeouts = {};
// Execute callback `delay` ms after this is called. If `delayUntilStable`
// is called repeatedly for the same key, the timeout is reset.
export function delayUntilStable(key, delay, callback) {
  clearTimeout(_dusTimeouts[key]);
  _dusTimeouts[key] = setTimeout(callback, delay);
};



// WEBPACK FOOTER //
// ./lib/rlink-utils/anim.js